import React from 'react';
import {Button, Space, Tag, Typography} from 'antd';
import {CloseOutlined} from '@ant-design/icons';
import './ListStateIndicator.scss';

const {Text} = Typography;

const ListStateIndicator = ({items, onReset, onRemove}) => {
    if (!items?.length) {
        return null;
    }

    return (
        <div className="list-state-indicator">
            <Space size={[8, 8]} wrap>
                <Text strong>Active list state:</Text>
                {items.map((item) => (
                    <Tag
                        key={item.key}
                        className="list-state-indicator__tag"
                        onClick={() => onRemove?.(item.key)}
                    >
                        <span>{item.label}: {String(item.value)}</span>
                        <CloseOutlined className="list-state-indicator__tag-icon"/>
                    </Tag>
                ))}
            </Space>
            <Button size="medium" onClick={onReset}>
                Reset
            </Button>
        </div>
    );
};

export default ListStateIndicator;
